import ja_all from "./ja/";

export default {
  ja: {
    ...ja_all,
  },
};
